<template>
  <v-app
    id="documentApp"
    class="bg-transparent"
    :class="{ 'pt-70-px': topMenuShow }"
  >
    <v-app-bar v-if="topMenuShow" dark fixed color="grey darken-3 z-index-6">
      <v-app-bar-nav-icon @click.stop="setLeftMenuShow(!leftMenuShow)"></v-app-bar-nav-icon>

      <v-app-bar-title>
        <!-- <v-img
          src="/images/logo.png"
          class="d-inline-block"
          max-width="110"
        ></v-img> -->
      </v-app-bar-title>

      <v-spacer></v-spacer>

      <template v-for="(item, index) in langList">
        <v-btn
          v-if="item.key !== lang"
          :key="index"
          class="my-2 rounded elevation-0 bg-transparent"
          small
          fab
          @click="ChangeState({ key: 'lang', val: item.key })"
        >
          {{ item.text }}
        </v-btn>
      </template>

      <v-divider class="mx-3" inset vertical></v-divider>

      <v-btn
        class="mx-3 bg-main"
        fab
        small
        dark
        @click.stop="$router.push({ path: '/member' })"
      >
        {{ loginUser.loginname.split('')[0] }}
      </v-btn>
      <v-btn
        class="mr-2 rounded elevation-0 bg-transparent"
        icon
        :title="$t('LOGOUT')"
        @click.stop="ChangeDialog('Logout')"
      >
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-app-bar>

    <DocumentMenu
      class="menu bg-transparent z-index-8"
      :editedAuth="editedAuth"
      :windowSizeName="windowSizeName"
      :leftMenu="leftMenuShow"
      :topMenuShow="topMenuShow"
      @setLeftMenuShow="setLeftMenuShow"
    ></DocumentMenu>

    <DocumentContent
      class="content z-index-5"
      :editedAuth="editedAuth"
    ></DocumentContent>

    <DocumentEdit v-if="editedAuth"></DocumentEdit>

    <Dialog></Dialog>
    <Snackbar></Snackbar>
  </v-app>
</template>
<script src="https://cdn.jsdelivr.net/npm/jquery@3.4"></script>
<script>
import { mapMutations, mapState } from 'vuex'

import Snackbar from '../components/Snackbar.vue'

import Dialog from '../components/Dialog.vue'

import DocumentMenu from '@/components/elements/DocumentMenu.vue'
import DocumentContent from '@/components/elements/DocumentContent.vue'
import DocumentEdit from '@/components/elements/DocumentEdit.vue'

export default {
  name: 'Document',

  props: ['windowSizeName'],

  components: { Snackbar, Dialog, DocumentMenu, DocumentContent, DocumentEdit },

  data() {
    return {
      content: null,
      topMenuShow: false,
      leftMenuShow: false
    }
  },

  computed: {
    ...mapState('common', ['lang', 'langList']),
    ...mapState('document', ['createMode']),
    ...mapState('auth', ['token', 'loginUser', 'authList']),
    editedAuth() {
      return this.authList.isEditer
    }
  },

  watch: {
    windowSizeName: {
      immediate: true,
      handler(val) {
        switch (val) {
          case 'md':
            this.topMenuShow = true
            break
          case 'sm':
            this.topMenuShow = true
            break
          case 'xs':
            this.topMenuShow = true
            break
          default:
            this.topMenuShow = false
        }
      }
    }
  },

  mounted() {
    if (!this.token) {
      this.$router.push({ name: 'Home' })
    }
  },

  methods: {
    ...mapMutations('common', ['ChangeDialog', 'ChangeState']),
    setLeftMenuShow(val) {
      this.leftMenuShow = val
    }
  }
}
</script>

<style lang="scss" scoped>
$main-color: #f05e21;
$sub-color: #0092be;

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

#documentApp {
  &::before,
  &::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &::before {
    background: linear-gradient(
      -45deg,
      #66d4da,
      $sub-color,
      #f8b05e,
      $main-color
    );
    background-size: 400% 400%;
    animation: gradient 30s ease infinite;
  }
  &::after {
    // background: $main-color;
    // opacity: 0.8;
    // background: radial-gradient(
    //   circle farthest-corner at 0% -60%,
    //   $main-color 0%,
    //   #f8b05e 45%,
    //   #66d4da 60%,
    //   $sub-color 90%
    // ) !important;
    // z-index: 0;
  }
}
.v-application--wrap {
  background-color: transparent !important;
}
</style>
